import { OutsideClick, Popup, PopupArrow } from '@cian/components';
import * as React from 'react';

import { IAgentSchema, IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { Link } from '../../common/components/link';
import { DownloadIcon, PrintIcon } from '../../icons';
import { ComplaintContainer } from '../complaint/container';
import { IconWarning } from './icons/icon_warning';
import * as Analytics from './tracking';

import { EFeedbackComplaint } from '../../store/complaint/feedback_complaint';

import * as styles from './index.css';

export interface IBottomControlPanelProps {
  pdfUrl: string;
  docxUrl: string;
  offer: IOfferSchema;
  agent: IAgentSchema | null;
}

export interface IBottomControlPanelDispatchProps {
  complaintFeedbackFormStatus(status: EFeedbackComplaint): void;
  openPrintModal(): void;
}

type IProps = IBottomControlPanelProps & IBottomControlPanelDispatchProps;

export interface IBottomControlPanelState {
  isComplaintsVisible: boolean;
  isOpenExports: boolean;
}

export class BottomControlPanel extends React.Component<IProps, IBottomControlPanelState> {
  public state = {
    isComplaintsVisible: false,
    isOpenExports: false,
  };

  public render() {
    return (
      <div className={styles['container']}>
        <span className={styles['tooltip-wrapper']}>
          <button
            className={styles['button_export']}
            onClick={() => {
              if (!this.state.isOpenExports) {
                Analytics.trackClickExport();
              }
              this.toggleExportsPopup();
            }}
          >
            <DownloadIcon />
            Экспорт
          </button>
          {this.state.isOpenExports && (
            <OutsideClick onOutsideClick={this.toggleExportsPopup}>
              <Popup arrow={PopupArrow.LEFT}>
                <div className={styles['export_links']}>
                  <Link
                    href={this.props.pdfUrl}
                    download
                    onClick={() => {
                      this.toggleExportsPopup();
                      Analytics.trackClickDownloadPdf();
                    }}
                  >
                    Скачать в PDF
                  </Link>
                  <Link
                    href={this.props.docxUrl}
                    download
                    onClick={() => {
                      this.toggleExportsPopup();
                      Analytics.trackClickDownloadDocx();
                    }}
                  >
                    Скачать в .docx
                  </Link>
                </div>
              </Popup>
            </OutsideClick>
          )}
        </span>
        <button
          onClick={() => {
            Analytics.trackClickPrintButton();
            this.props.openPrintModal();
          }}
          className={styles['button_print']}
        >
          <PrintIcon />
          Печать
        </button>
        <span className={styles['tooltip-wrapper']}>
          <button
            className={styles['button_complaint']}
            onClick={() => {
              if (!this.state.isComplaintsVisible) {
                Analytics.trackClickComplaint(this.props.offer, this.props.agent);
              }
              this.toggleComplaintPopup();
            }}
          >
            <IconWarning />
            Пожаловаться
          </button>
          {this.state.isComplaintsVisible && (
            <OutsideClick onOutsideClick={this.toggleComplaintPopup}>
              <div className={styles['complaint']}>
                <ComplaintContainer handleOutsideClick={this.toggleComplaintPopup} />
              </div>
            </OutsideClick>
          )}
        </span>
      </div>
    );
  }

  private toggleExportsPopup = () => {
    this.setState({
      isOpenExports: !this.state.isOpenExports,
    });
  };

  private toggleComplaintPopup = () => {
    this.setState(
      {
        isComplaintsVisible: !this.state.isComplaintsVisible,
      },
      () => {
        if (!this.state.isComplaintsVisible) {
          this.props.complaintFeedbackFormStatus(EFeedbackComplaint.default);
        }
      },
    );
  };
}
